import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { GenericInput } from "../../../Shared/components/GenericInput";
import { GenericButton } from "../../../Shared/components/GenericButton";
import { OverlayLoader } from "../../../Shared/components/Overlay";
import { AuthService } from "../services/AuthService";
import { ToastResponse } from "../../../Shared/types/ToastProps";
import { Toast } from "../../../Shared/components/Toast";
import { OTPInput } from "../../../Shared/components/OTPInput";

export const ResetPasswordForm = () => {
  const navigate = useNavigate();

  const message = "Account Login Process, Please Wait";
  const [showToast, setShowToast] = useState(false);
  const [toast, setToast] = useState<ToastResponse>();

  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState("");

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [confirmPassword, setConfirmPPassword] = useState("");
  const [confirmPasswordError, setConfirmPPasswordError] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const onCode = (val: string) => {
    setCode(val);
    setCodeError(val.includes("@") ? "" : "");
  };

  const onPassword = (val: string) => {
    setPassword(val);
    setPasswordError(val?.length < 4 ? "" : "");
  };

  const onConfirmPassword = (val: string) => {
    setConfirmPPassword(val);
    setConfirmPPasswordError(val.trim() === "" ? " " : "");
  };

  const onOTPSubmit = async (_otp: string) => {};

  const resetForm = () => {
    setCode("");
    setCodeError("");

    setPassword("");
    setPasswordError("");

    setConfirmPPassword("");
    setConfirmPPasswordError("");
  };
  const isConfirmPasswordValid =
    confirmPassword.trim() !== "" && confirmPassword === password;

  const isFormValid =
    code.trim() !== "" &&
    password.trim() !== "" &&
    !codeError &&
    !passwordError &&
    isConfirmPasswordValid;

  const loginAction = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!code || !password) {
      if (!code) setCodeError("Code is required");
      if (!password) setPasswordError("Password is required");
      return;
    } else {
      try {
        setIsLoading(true);
        await AuthService.resetPassword(code, password);
        navigate("/auth/login");
        resetForm();
      } catch (error: any) {
        setShowToast(true);
        setToast({ message: `Error ${error?.message}`, type: "error" });
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="relative">
        <div className="w-full h-100">
          <h1 className="text-xl md:text-2xl font-bold leading-tight mt-12">
            Reset Password
          </h1>
          <form className="mt-6" onSubmit={loginAction}>
            <GenericInput
              label="Code"
              value={code}
              onChange={onCode}
              type="number"
              error={codeError}
              placeholder="Enter your code"
              required={true}
            />

            <div className="hidden">
              <OTPInput onSubmit={onOTPSubmit} />
            </div>

            <div className="grid gap-6 mb-6 md:grid-cols-2 mb-6">
              <GenericInput
                containerClassName=""
                label="Password"
                value={password}
                onChange={onPassword}
                type="password"
                error={passwordError}
                placeholder="Enter your password"
                required={true}
              />

              <GenericInput
                containerClassName=""
                label="Confirm Password"
                value={confirmPassword}
                onChange={onConfirmPassword}
                type="password"
                error={confirmPasswordError}
                placeholder="Confirm your password"
                required={true}
              />
            </div>

            <GenericButton type="submit" disabled={!isFormValid}>
              Submit
            </GenericButton>
          </form>
        </div>
      </div>
      {showToast && (
        <Toast
          type={toast?.type}
          message={toast?.message ?? ""}
          onClose={() => setShowToast(false)}
        />
      )}
      {isLoading && <OverlayLoader message={message} />}
    </>
  );
};
